import Accordion from "./Accordion";
import SelectBinderLetterCovers from "./SelectBinderLetterCovers";
import { useEffect } from "react";
import Accordions from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
const SelectedBinderLetterCoverByCoverType = ({
  coverTypes,
  locations,
  coverOfCoverType,
  getCoversasisValue,
  handleCoverChange,
  handleChecked,
  storeBinder,
  defaultSelectedCheckedValue,
  buildings,
}) => {
  const config = {
    LOCATION: {
      byLocation: true,
    },
  };

  const coverConfig = config[coverTypes] || {};
  // const items = locations.map((location) => ({
  //   component: (
  //     <SelectBinderLetterCovers
  //       location={location}
  //       coverOfCoverType={coverOfCoverType}
  //       getCoversasisValue={getCoversasisValue}
  //       handleChecked={handleChecked}
  //       storeBinder={storeBinder}
  //       defaultSelectedCheckedValue={defaultSelectedCheckedValue}
  //     />
  //   ),
  //   location,
  // }));

  const generateComponentsForLocation = (location) => {
    // If the buildings data exists for the current location
    if (buildings && buildings[location.id].buildings) {
      return Object.keys(buildings[location.id].buildings).map(
        (buildingKey, index) => {
          return (
            <>
              <Accordions
                defaultActiveKey="0"
                style={{
                  padding: "86px",
                  paddingTop: "5px",
                  paddingBottom: "0px",
                }}
              >
                <Card>
                  <Accordions.Toggle as={Card.Header} eventKey={"" + index}>
                    <h3 style={{ color: "black" }}>
                      Property-{parseInt(buildingKey) + 1}{" "}
                    </h3>
                  </Accordions.Toggle>
                  <Accordions.Collapse eventKey={index + ""}>
                    <div>
                      <SelectBinderLetterCovers
                        location={location}
                        buildingIndex={buildingKey}
                        locationIndex={location.id}
                        building={buildings[location.id].buildings[buildingKey]} // passing building details
                        coverOfCoverType={coverOfCoverType}
                        getCoversasisValue={getCoversasisValue}
                        handleChecked={handleChecked}
                        storeBinder={storeBinder}
                        defaultSelectedCheckedValue={
                          defaultSelectedCheckedValue
                        }
                        buildingName={buildingKey + 1}
                      />
                    </div>
                  </Accordions.Collapse>
                </Card>
              </Accordions>
            </>
          );
        }
      );
    } else {
      // Revert to the older structure
      return (
        <SelectBinderLetterCovers
          location={location}
          coverOfCoverType={coverOfCoverType}
          getCoversasisValue={getCoversasisValue}
          handleChecked={handleChecked}
          storeBinder={storeBinder}
          defaultSelectedCheckedValue={defaultSelectedCheckedValue}
        />
      );
    }
  };

  const items = locations.map((location) => ({
    component: generateComponentsForLocation(location),
    location,
  }));
  return (
    <>
      {coverConfig.byLocation && <Accordion items={items} />}

      {!coverConfig.byLocation && (
        <SelectBinderLetterCovers
          coverOfCoverType={coverOfCoverType}
          getCoversasisValue={getCoversasisValue}
          handleChecked={handleChecked}
          storeBinder={storeBinder}
          defaultSelectedCheckedValue={defaultSelectedCheckedValue}
        />
      )}
    </>
  );
};
export default SelectedBinderLetterCoverByCoverType;
